// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const AdoptionProvisionEnum = {
  "ADOPTION_PROVISION_1_CURRENT_FINANCIAL_IMPACTS": "Adoption_provision_1_Current_financial_impacts",
  "ADOPTION_PROVISION_2_ANTICIPATED_FINANCIAL_IMPACTS": "Adoption_provision_2_Anticipated_financial_impacts",
  "ADOPTION_PROVISION_3_TRANSITION_PLANNING": "Adoption_provision_3_Transition_planning",
  "ADOPTION_PROVISION_4_SCOPE_3_GHG_EMISSIONS": "Adoption_provision_4_Scope_3_GHG_emissions",
  "ADOPTION_PROVISION_5_COMPARATIVES_FOR_SCOPE_3_GHG_EMISSIONS": "Adoption_provision_5_Comparatives_for_Scope_3_GHG_emissions",
  "ADOPTION_PROVISION_6_COMPARATIVES_FOR_METRICS": "Adoption_provision_6_Comparatives_for_metrics",
  "ADOPTION_PROVISION_7_ANALYSIS_OF_TRENDS": "Adoption_provision_7_Analysis_of_trends"
};

const PartyRoleTypeEnum = {
  "PARENT_ENTITY": "Parent_Entity",
  "SUBSIDIARY": "Subsidiary",
  "SUPPLIER": "Supplier"
};

const PartyRelationshipTypeEnum = {
  "ORGANISATION_ROLLUP": "OrganisationRollup"
};

const AggregateWithParentEnum = {
  "AGGREGATE_WITH_PARENT": "Aggregate_With_Parent",
  "KEEP_SEPARATE_FROM_PARENT": "Keep_Separate_From_Parent"
};

const CarbonAccountSelectTypeEnum = {
  "EMISSION_ACCOUNT": "EmissionAccount",
  "REDUCTION_ACCOUNT": "ReductionAccount",
  "OFFSET_ACCOUNT": "OffsetAccount",
  "BIOGENIC_ACCOUNT": "BiogenicAccount",
  "AVOIDED_EMISSION_ACCOUNT": "AvoidedEmissionAccount"
};

const AppGroup = {
  "ADMINISTRATOR": "Administrator",
  "AUDITOR": "Auditor",
  "CONTRIBUTOR": "Contributor",
  "EDITOR": "Editor"
};

const GovernanceProcessSelectTypeEnum = {
  "INFORM_GOVERNANCE": "InformGovernance",
  "STRATEGY_DEVELOPMENT": "StrategyDevelopment",
  "GOVERNANCE_METRICS_TARGETS": "GovernanceMetricsTargets",
  "GOVERNANCE_BODY_ENGAGEMENT": "GovernanceBodyEngagement",
  "MANAGEMENT_OVERSIGHT": "ManagementOversight"
};

const GovernanceDataSelectTypeEnum = {
  "GOVERNANCE_BODY": "GovernanceBody",
  "GOVERNANCE_OVERSIGHT_ACTIVITIES": "GovernanceOversightActivities",
  "MANAGEMENT_ACCOUNTABILITIES": "ManagementAccountabilities"
};

const ScenarioAnalysisProcessTypeEnum = {
  "STANDALONE": "Standalone",
  "INTEGRATED_IN_STRATEGY_PROCESSES": "Integrated_in_Strategy_Processes"
};

const ScenarioEndpointEnum = {
  "TEMPERATURE": "Temperature",
  "YEAR": "Year"
};

const InitiativeStatusEnum = {
  "INVESTIGATING": "Investigating",
  "PLANNING": "Planning",
  "IMPLEMENTING": "Implementing",
  "IMPLEMENTED": "Implemented"
};

const EmissionCategoryEnum = {
  "CATEGORY_1": "Category_1",
  "CATEGORY_2": "Category_2",
  "CATEGORY_3": "Category_3",
  "CATEGORY_4": "Category_4",
  "CATEGORY_5": "Category_5",
  "CATEGORY_6": "Category_6"
};

const EmissionScopeEnum = {
  "SCOPE_1": "Scope_1",
  "SCOPE_2": "Scope_2",
  "SCOPE_3": "Scope_3"
};

const EmissionUnitEnum = {
  "EMPLOYEES": "Employees",
  "KG": "Kg",
  "KW": "Kw",
  "KWH": "Kwh",
  "LITRES": "Litres",
  "METRES_CUBED": "MetresCubed",
  "MILLION_DOLLARS_REVENUE": "MillionDollarsRevenue",
  "NIGHTS": "Nights",
  "PASSENGER_PER_KM": "PassengerPerKm",
  "PER_CAPITA": "PerCapita",
  "PERCENTAGE": "Percentage",
  "QUANTITY": "Quantity",
  "TONNES": "Tonnes",
  "TONNES_PER_KM": "TonnesPerKm"
};

const AmountPercentEnum = {
  "AMOUNT": "Amount",
  "PERCENT": "Percent"
};

const EmissionsConsolidationApproachEnum = {
  "EQUITY_SHARE": "Equity_Share",
  "FINANCIAL_CONTROL": "Financial_Control",
  "OPERATIONAL_CONTROL": "Operational_Control"
};

const RiskMgmtProcessTypeEnum = {
  "IDENTIFY": "Identify",
  "ASSESS": "Assess",
  "MANAGE": "Manage",
  "REPORT": "Report"
};

const OffsetSchemeTypeEnum = {
  "CERTIFIED": "Certified",
  "VERIFIED": "Verified"
};

const OffsetRelianceEnum = {
  "PERCENTAGE": "Percentage",
  "VALUE": "Value",
  "NONE": "None"
};

const TargetTypeEnum = {
  "ABSOLUTE_TARGET": "Absolute_Target",
  "INTENSITY_TARGET": "Intensity_Target"
};

const PublishedToEnum = {
  "PUBLIC": "Public",
  "STAKEHOLDER": "Stakeholder",
  "ASSURANCE": "Assurance",
  "REGULATOR": "Regulator"
};

const FinancialImpactCategoryEnum = {
  "ASSETS": "Assets",
  "CAPEX": "Capex",
  "COST_OF_GOODS_SOLD": "Cost_Of_Goods_Sold",
  "FINANCE": "Finance",
  "INTEREST_COSTS": "Interest_Costs",
  "OPEX": "Opex",
  "NET_PROFIT_AFTER_TAX": "Net_Profit_After_Tax",
  "REVENUE": "Revenue"
};

const ValueChainEnum = {
  "UPSTREAM": "Upstream",
  "DIRECT_OPERATIONS": "Direct_Operations",
  "DOWNSTREAM": "Downstream",
  "ALL_SEGMENTS": "All_Segments",
  "OTHER": "Other"
};

const OpportunityEnum = {
  "ENERGY_SOURCE": "Energy_Source",
  "MARKETS": "Markets",
  "PRODUCTS_AND_SERVICES": "Products_and_Services",
  "RESILIENCE": "Resilience",
  "RESOURCE_EFFICIENCY": "Resource_Efficiency"
};

const PriorityEnum = {
  "HIGHEST": "Highest",
  "HIGH": "High",
  "MEDIUM": "Medium",
  "LOW": "Low",
  "LOWEST": "Lowest"
};

const LikelihoodofOccurringEnum = {
  "NONE": "None",
  "LOW": "Low",
  "MEDIUM": "Medium",
  "HIGH": "High"
};

const PrimaryPotentialFinancialImpactEnum = {
  "INCREASED_ACCESS_TO_CAPITAL": "Increased_Access_to_Capital",
  "INCREASED_ACCESS_TO_RESOURCES": "Increased_Access_to_Resources",
  "INCREASED_CAPITAL_EXPENDITURES": "Increased_Capital_Expenditures",
  "INCREASED_CREDIT_RISK": "Increased_Credit_Risk",
  "INCREASED_DIRECT_COSTS": "Increased_Direct_Costs",
  "INCREASED_INDIRECT_OPERATING_COSTS": "Increased_Indirect_Operating_Costs",
  "INCREASED_INSURANCE_CLAIMS_LIABILITY": "Increased_Insurance_Claims_Liability",
  "INCREASED_REVENUE": "Increased_Revenue",
  "DECREASED_ACCESS_TO_CAPITAL": "Decreased_Access_to_Capital",
  "DECREASED_ASSET_VALUE_OR_ASSET_USEFUL_LIFE_LEADING_TO_WRITEOFFS_ASSET_IMPAIRMENT_OR_EARLY_RETIREMENT_OF_EXISTING_ASSETS": "Decreased_Asset_Value_or_Asset_Useful_Life_Leading_to_Writeoffs_Asset_Impairment_or_Early_Retirement_of_Existing_Assets",
  "DECREASED_OPEX": "Decreased_OPEX",
  "DECREASED_REVENUES_DUE_TO_REDUCED_DEMAND_FOR_PRODUCTS_AND_SERVICES": "Decreased_Revenues_Due_to_Reduced_Demand_For_Products_and_Services",
  "DECREASED_REVENUES_DUE_TO_REDUCED_PRODUCTION_CAPACITY": "Decreased_Revenues_Due_to_Reduced_Production_Capacity",
  "DEVALUATION_OF_COLLTATERAL_OR_POTENTIAL_FOR_STRANDED_ILLIQUID_ASSETS": "Devaluation_of_Colltateral_or_Potential_For_Stranded_Illiquid_Assets",
  "INCREASED_CAPITAL_EXPENDITURE": "Increased_Capital_Expenditure",
  "INCREASED_GROSS_MARGIN": "Increased_Gross_Margin",
  "INCREASED_OPERATING_EXPENDITURE": "Increased_Operating_Expenditure",
  "INCREASED_OR_DECREASED_REVENUE": "Increased_Or_Decreased_Revenue",
  "REDUCED_GROSS_MARGIN": "Reduced_Gross_Margin",
  "REDUCED_PROFITABILITY_OR_INVESTMENT_PORTFOLIOS": "Reduced_Profitability_or_Investment_Portfolios",
  "OTHER_PLEASE_SPECIFY": "Other_Please_Specify"
};

const RiskType = {
  "ACUTE_PHYSICAL": "Acute_Physical",
  "CHRONIC_PHYSICAL": "Chronic_Physical",
  "MARKET": "Market",
  "PHYSICAL": "Physical",
  "POLICY_AND_LEGAL": "Policy_and_Legal",
  "REPUTATION": "Reputation",
  "TECHNOLOGY": "Technology",
  "TRANSITION": "Transition"
};

const ClimatePlanningHorizonsEnum = {
  "CURRENT": "Current",
  "SHORT_TERM": "Short_Term",
  "MEDIUM_TERM": "Medium_Term",
  "LONG_TERM": "Long_Term",
  "ALL_CLIMATE_PLANNING_HORIZONS": "All_Climate_Planning_Horizons"
};

const ScenarioTemperatureAlignmentEnum = {
  "ONE_POINT_FIVE_DEGREES_CELSIUS": "One_Point_Five_Degrees_Celsius",
  "ONE_POINT_SIX_TO_TWO_DEGREES_CELSIUS": "One_Point_Six_to_Two_Degrees_Celsius",
  "TWO_POINT_ONE_TO_THREE_DEGREES_CELSIUS": "Two_Point_One_to_Three_Degrees_Celsius",
  "THREE_POINT_ONE_TO_FOUR_DEGREES_CELSIUS": "Three_Point_One_to_Four_Degrees_Celsius",
  "FOUR_POINT_ONE_DEGREES_AND_ABOVE": "Four_Point_One_Degrees_and_Above",
  "UNKNOWN": "Unknown"
};

const ScenarioAnalysisCoverageEnum = {
  "COMPANY_WIDE": "Company_Wide",
  "VALUE_CHAIN_SEGMENT": "Value_Chain_Segment",
  "BUSINESS_DIVISION": "Business_Division",
  "FACILITY": "Facility",
  "COUNTRY_OR_AREA": "Country_or_Area",
  "PRODUCT_LEVEL": "Product_Level",
  "PORTFOLIO_LEVEL": "Portfolio_Level",
  "OTHER": "Other"
};

const ScenarioAnalysisMethodEnum = {
  "QUALITATIVE": "Qualitative",
  "QUANTITATIVE": "Quantitative",
  "BOTH": "Both",
  "NONE": "None",
  "NONE_WILL_ADD_IN_SHORT_TERM": "None_Will_Add_In_Short_Term",
  "NONE_WILL_ADD_IN_MEDIUM_TERM": "None_Will_Add_In_Medium_Term",
  "NONE_WILL_ADD_IN_LONG_TERM": "None_Will_Add_In_Long_Term"
};

const CurrencyEnum = {
  "AUD": "AUD",
  "EURO": "EURO",
  "GBP": "GBP",
  "RMB": "RMB",
  "USD": "USD",
  "NZD": "NZD"
};

const ProcessTypeEnum = {
  "ASSESS": "Assess",
  "MONITOR": "Monitor",
  "INFORM": "Inform",
  "DECIDE": "Decide",
  "INTEGRATED": "Integrated"
};

const ProcessFrequencyEnum = {
  "DAILY": "Daily",
  "WEEKLY": "Weekly",
  "FORTNIGHTLY": "Fortnightly",
  "MONTHLY": "Monthly",
  "QUARTERLY": "Quarterly",
  "HALF_YEARLY": "Half_Yearly",
  "YEARLY": "Yearly",
  "EVERY_TWO_YEARS": "Every_Two_Years",
  "EVERY_THREE_YEARS": "Every_Three_Years",
  "ADHOC": "Adhoc",
  "NEVER": "Never"
};

const DisclosureStatusEnum = {
  "DRAFT": "Draft",
  "PUBLISHED": "Published",
  "INACTIVE": "Inactive"
};

const OrgidTypeEnum = {
  "IATI": "IATI",
  "STOCK_SYMBOL": "Stock_Symbol",
  "NZBN": "NZBN",
  "ABN": "ABN"
};

const CountriesEnum = {
  "NEW_ZEALAND": "New_Zealand",
  "AUSTRALIA": "Australia",
  "USA": "USA",
  "CHINA": "China"
};

const { AdoptionProvision, Evidence, PartyRelationship, CarbonAccount, AuditLog, AvoidedEmissionAccountEntry, BiogenicAccountEntry, Comment, AppUsers, GovernanceProcesses, GovernanceData, EmissionReductionPathway, ScenarioAnalysisProcess, GhgEmissionUncertainty, GhgMethodAssumption, SupplementalDisclosureData, RestatementofComparatives, AssetRegister, BusinessActivity, Location, Asset, PlanningHorizon, EmissionsIntensityMeasures, OffsetAccountEntry, EmissionAccountEntry, CarbonAccountingLedgers, ReductionAccountEntry, TransitionPlanningDataSet, ImpactsDataSet, OpportunityDataSet, MetricsDataSet, IndustryMetric, Kpi, EmissionsExclusions, EmissionsNarrative, TargetsDataSet, RiskManagementProcessesRecords, ClimatePlanningHorizon, Scenarios, RisksBaseDataSet, StrategyBaseData, CapitalDeploymentFundingProcess, Targets, GovernanceBaseDataSet, Opportunities, MetricsAndTargetsRecords, RiskManagementProcesses, Organisation, Impacts, Risks, BusinessPlanningHorizon, ScenarioAnalysis, DisclosurePeriod, Disclosure, AdoptionProvisionSupplementalDisclosureData, CarbonAccountCarbonAccountingLedgers, GovernanceDataGovernanceProcesses, GovernanceDataGovernanceBaseDataSet, EmissionReductionPathwayScenarios, ScenarioAnalysisProcessScenarioAnalysis, GhgEmissionUncertaintyMetricsDataSet, GhgMethodAssumptionMetricsDataSet, AssetAssetRegister, LocationBusinessActivity, BusinessActivityMetricsDataSet, AssetMetricsDataSet, ClimatePlanningHorizonPlanningHorizon, PlanningHorizonStrategyBaseData, EmissionsIntensityMeasuresMetricsDataSet, TargetsReductionAccountEntry, TransitionPlanningDataSetStrategyBaseData, ImpactsImpactsDataSet, ImpactsDataSetStrategyBaseData, OpportunitiesOpportunityDataSet, OpportunityDataSetStrategyBaseData, MetricsDataSetMetricsAndTargetsRecords, MetricsAndTargetsRecordsIndustryMetric, MetricsAndTargetsRecordsKpi, EmissionsExclusionsEmissionsNarrative, EmissionsNarrativeMetricsAndTargetsRecords, TargetsTargetsDataSet, TargetsDataSetMetricsAndTargetsRecords, RiskManagementProcessesRiskManagementProcessesRecords, CapitalDeploymentFundingProcessClimatePlanningHorizon, BusinessPlanningHorizonClimatePlanningHorizon, ScenariosScenarioAnalysis, RisksRisksBaseDataSet, RisksBaseDataSetStrategyBaseData, ScenarioAnalysisStrategyBaseData, OpportunitiesImpacts, RisksImpacts } = initSchema(schema);

export {
  AdoptionProvision,
  Evidence,
  PartyRelationship,
  CarbonAccount,
  AuditLog,
  AvoidedEmissionAccountEntry,
  BiogenicAccountEntry,
  Comment,
  AppUsers,
  GovernanceProcesses,
  GovernanceData,
  EmissionReductionPathway,
  ScenarioAnalysisProcess,
  GhgEmissionUncertainty,
  GhgMethodAssumption,
  SupplementalDisclosureData,
  RestatementofComparatives,
  AssetRegister,
  BusinessActivity,
  Location,
  Asset,
  PlanningHorizon,
  EmissionsIntensityMeasures,
  OffsetAccountEntry,
  EmissionAccountEntry,
  CarbonAccountingLedgers,
  ReductionAccountEntry,
  TransitionPlanningDataSet,
  ImpactsDataSet,
  OpportunityDataSet,
  MetricsDataSet,
  IndustryMetric,
  Kpi,
  EmissionsExclusions,
  EmissionsNarrative,
  TargetsDataSet,
  RiskManagementProcessesRecords,
  ClimatePlanningHorizon,
  Scenarios,
  RisksBaseDataSet,
  StrategyBaseData,
  CapitalDeploymentFundingProcess,
  Targets,
  GovernanceBaseDataSet,
  Opportunities,
  MetricsAndTargetsRecords,
  RiskManagementProcesses,
  Organisation,
  Impacts,
  Risks,
  BusinessPlanningHorizon,
  ScenarioAnalysis,
  DisclosurePeriod,
  Disclosure,
  AdoptionProvisionSupplementalDisclosureData,
  CarbonAccountCarbonAccountingLedgers,
  GovernanceDataGovernanceProcesses,
  GovernanceDataGovernanceBaseDataSet,
  EmissionReductionPathwayScenarios,
  ScenarioAnalysisProcessScenarioAnalysis,
  GhgEmissionUncertaintyMetricsDataSet,
  GhgMethodAssumptionMetricsDataSet,
  AssetAssetRegister,
  LocationBusinessActivity,
  BusinessActivityMetricsDataSet,
  AssetMetricsDataSet,
  ClimatePlanningHorizonPlanningHorizon,
  PlanningHorizonStrategyBaseData,
  EmissionsIntensityMeasuresMetricsDataSet,
  TargetsReductionAccountEntry,
  TransitionPlanningDataSetStrategyBaseData,
  ImpactsImpactsDataSet,
  ImpactsDataSetStrategyBaseData,
  OpportunitiesOpportunityDataSet,
  OpportunityDataSetStrategyBaseData,
  MetricsDataSetMetricsAndTargetsRecords,
  MetricsAndTargetsRecordsIndustryMetric,
  MetricsAndTargetsRecordsKpi,
  EmissionsExclusionsEmissionsNarrative,
  EmissionsNarrativeMetricsAndTargetsRecords,
  TargetsTargetsDataSet,
  TargetsDataSetMetricsAndTargetsRecords,
  RiskManagementProcessesRiskManagementProcessesRecords,
  CapitalDeploymentFundingProcessClimatePlanningHorizon,
  BusinessPlanningHorizonClimatePlanningHorizon,
  ScenariosScenarioAnalysis,
  RisksRisksBaseDataSet,
  RisksBaseDataSetStrategyBaseData,
  ScenarioAnalysisStrategyBaseData,
  OpportunitiesImpacts,
  RisksImpacts,
  AdoptionProvisionEnum,
  PartyRoleTypeEnum,
  PartyRelationshipTypeEnum,
  AggregateWithParentEnum,
  CarbonAccountSelectTypeEnum,
  AppGroup,
  GovernanceProcessSelectTypeEnum,
  GovernanceDataSelectTypeEnum,
  ScenarioAnalysisProcessTypeEnum,
  ScenarioEndpointEnum,
  InitiativeStatusEnum,
  EmissionCategoryEnum,
  EmissionScopeEnum,
  EmissionUnitEnum,
  AmountPercentEnum,
  EmissionsConsolidationApproachEnum,
  RiskMgmtProcessTypeEnum,
  OffsetSchemeTypeEnum,
  OffsetRelianceEnum,
  TargetTypeEnum,
  PublishedToEnum,
  FinancialImpactCategoryEnum,
  ValueChainEnum,
  OpportunityEnum,
  PriorityEnum,
  LikelihoodofOccurringEnum,
  PrimaryPotentialFinancialImpactEnum,
  RiskType,
  ClimatePlanningHorizonsEnum,
  ScenarioTemperatureAlignmentEnum,
  ScenarioAnalysisCoverageEnum,
  ScenarioAnalysisMethodEnum,
  CurrencyEnum,
  ProcessTypeEnum,
  ProcessFrequencyEnum,
  DisclosureStatusEnum,
  OrgidTypeEnum,
  CountriesEnum
};